export default __webpack_public_path__ + "static/media/drug.ab60039b.png";